import { arrayOf, bool, shape, string } from "prop-types";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import Filters from "./filters";
import FiltersAnixe from "./filtersAnixeProduct";

const Container = ({
  isAnixeTourism,
  isInternationalTourism,
  filters,
  facetsHidden,
}) => {
  const filteredFilters =
    isArrayHasItems(filters) &&
    filters.filter((singleFilter) =>
      isInternationalTourism
        ? singleFilter.attribute_code !== "review_summary_filter"
        : singleFilter.attribute_options?.length !== 0
    );

  if (isAnixeTourism) {
    return <FiltersAnixe filters={filters} facetsHidden={facetsHidden} />;
  }

  return <Filters filters={filteredFilters} facetsHidden={facetsHidden} />;
};
Container.propTypes = {
  isAnixeTourism: bool,
  isInternationalTourism: bool,
  filters: arrayOf(
    shape({
      attribute_label: string,
      attribute_type: string,
      values: shape({}),
    })
  ).isRequired,
  facetsHidden: arrayOf(string),
};

Container.defaultProps = {
  facetsHidden: [],
  isAnixeTourism: false,
  isInternationalTourism: false,
};
export default Container;
